<template>
  <div class="dragon-tiger-rank-v2">
    <!-- 页面头部 -->
    <div class="page-header">
      <div class="header-content">
        <div class="title-wrapper">
          <Icon type="ios-trophy" size="32" color="#f39c12"/>
          <h1>班主任龙虎榜</h1>
          <span class="subtitle">班主任业绩排行榜</span>
        </div>
        <!-- 业绩播报跑马灯 -->
        <div class="news-marquee" v-if="newOrderList.length > 0">
          <div class="marquee-content">
            <span v-for="(item, index) in newOrderList" :key="index" class="marquee-item">
              <Icon type="ios-notifications" size="14" color="#ff9900"/>
              {{ item }} 🎉🎉🎉
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- 主内容区 -->
    <div class="main-content">
      <!-- 搜索条件 -->
      <Card class="search-card">
        <Form :label-width="80" :show-message="false">
          <Row :gutter="24">
         <i-col :xs="24" :sm="12" :md="6">
              <Form-item label="月份">
                <DatePicker
                  v-model="queryParam.month"
                  type="month"
                  format="yyyy-MM"
                  placeholder="选择月份"
                  @on-change="search"
                  style="width: 100%"/>
              </Form-item>
            </i-col>
         <i-col :xs="24" :sm="12" :md="6">
              <Form-item label="班主任" prop="adviserId">
                <admin-user-select
                  :status="1"
                  adminGroupCode="userStudyAdviser"
                  :need-default-study-adviser="0"
                  placeholder="全部班主任"
                  v-model="queryParam.adviserId">
                </admin-user-select>
              </Form-item>
            </i-col>
            <i-col :xs="24" :sm="12" :md="6">
              <Form-item label="师资" prop="tchChannel">
                <Select
                  v-model="queryParam.tchChannel"
                  placeholder="请选择师资"
                  clearable
                  @on-change="search"
                  style="width: 100%">
                  <Option
                    v-for="item in $constant.tchChannel"
                    :key="item.code"
                    :value="item.code">
                    {{ item.text }}
                  </Option>
                </Select>
              </Form-item>
            </i-col>
            <i-col :xs="12" :sm="6" :md="4" style="display: flex; align-items: center;">
              <Button type="primary" :loading="searchLoading" icon="ios-search" @click="search">
                搜索
              </Button>
<!--              <Button type="info" icon="ios-eye" @click="viewDetail" style="margin-left: 8px;">-->
<!--                出单节奏图-->
<!--              </Button>-->
            </i-col>
          </Row>
        </Form>
      </Card>

      <!-- 排行榜表格 -->
      <Card class="rank-card">
        <div class="rank-card-header">
          <span class="rank-title">排行榜</span>
          <Button type="primary" icon="ios-download-outline" :loading="exportLoading" @click="exportToImage">
            导出图片
          </Button>
        </div>
        <div ref="exportArea" class="table-wrapper">
          <table class="rank-table">
            <thead>
              <tr>
                <th class="rank-col">排名</th>
                <th class="name-col">姓名</th>
                <th class="quantity-col">单量</th>
                <th class="amount-col">业绩</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in rankingData"
                :key="index"
                :class="['rank-row', getRankClass(item.rank)]"
              >
                <td class="rank-col">
                  <div class="rank-badge" :class="getMedalClass(item.rank)">
                    <span v-if="item.rank <= 3">{{ getMedalIcon(item.rank) }}</span>
                    <span v-else>{{ item.rank }}</span>
                  </div>
                </td>
                <td class="name-col">
                  <a v-if="canSeeRowDetail(item)" @click="goToPerformanceDetail(item)">{{ item.adviserName }}</a>
                  <span v-else>{{ item.adviserName }}</span>
                </td>
                <td class="quantity-col">{{ item.quantity }}</td>
                <td class="amount-col">¥ {{ $numeral(item.amount).format('0,0') }}</td>
              </tr>

              <!-- 总计行：仅展示汇总，不作为全员详情入口 -->
              <tr class="total-row">
                <td class="total-col total-label" colspan="2">
                  <strong>Total</strong>
                </td>
                <td class="total-col">
                  <strong>{{ totalQuantity }}</strong>
                </td>
                <td class="total-col">
                  <strong>¥ {{ $numeral(totalAmount).format('0,0') }}</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 空数据提示 -->
        <div v-if="rankingData.length === 0 && !searchLoading" class="empty-data">
          <Icon type="ios-inbox" size="60" color="#dcdee2"/>
          <p>暂无数据</p>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
import html2canvas from 'html2canvas'

export default {
  name: 'StudyAdviserDragonTigerList',
  data () {
    return {
      searchLoading: false,
      exportLoading: false,
      queryParam: {
        month: this.$moment().format('YYYY-MM'),
        adviserId: '',
        tchChannel: 1
      },
      rankingData: [],
      totalAdvisers: 0,
      totalQuantity: 0,
      totalAmount: 0,
      newOrderList: []
    }
  },
  created () {
    this.search()
    this.getNewOrders()
    this.timer = setInterval(this.getNewOrders, 10 * 1000)
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  computed: {
    monthName () {
      return this.$moment(this.queryParam.month).format('YYYY 年 M 月')
    }
  },
  watch: {
    'queryParam.adviserId' (newVal) {
      // 避免初始化和清空时触发搜索
      if (this.searchLoading) return
      this.search()
    }
  },
  methods: {
    search () {
      this.searchLoading = true
      const month = this.$moment(this.queryParam.month).format('YYYY-MM')

      this.$http.get('/fundPackage/studyAdviserDragonTigerList', {
        params: {
          month: month,
          adviserId: this.queryParam.adviserId || null,
          tchChannel: this.queryParam.tchChannel || null
        }
      }).then(res => {
        if (res && res.data) {
          this.processData(res.data)
        }
        this.searchLoading = false
      }).catch(() => {
        this.searchLoading = false
      })
    },

    processData (data) {
      if (!data) {
        this.rankingData = []
        this.totalAdvisers = 0
        this.totalQuantity = 0
        this.totalAmount = 0
        return
      }

      // 从接口获取统计数据
      this.totalAdvisers = data.totalAdvisers || 0
      this.totalQuantity = data.totalQuantity || 0
      this.totalAmount = data.totalAmount || 0

      // 将数据转换为排行榜格式
      const rankingList = data.rankingList || []

      this.rankingData = rankingList.filter(item => !this.isTotalRow(item)).map(item => ({
        rank: item.rank,
        adviserId: item.adviserId,
        adviserName: item.adviserName,
        quantity: item.completed || 0,
        amount: item.completedAmount || 0,
        canSeeDetail: item.canSeeDetail
      }))
    },

    getRankClass (rank) {
      if (rank === 1) return 'rank-1'
      if (rank === 2) return 'rank-2'
      if (rank === 3) return 'rank-3'
      return ''
    },

    getMedalClass (rank) {
      if (rank === 1) return 'medal-gold'
      if (rank === 2) return 'medal-silver'
      if (rank === 3) return 'medal-bronze'
      return ''
    },

    getMedalIcon (rank) {
      if (rank === 1) return '🥇'
      if (rank === 2) return '🥈'
      if (rank === 3) return '🥉'
      return rank
    },

    isTotalRow (item) {
      if (!item) return true
      const name = String(item.adviserName || '').replace(/\s/g, '')
      return name === 'Total' || name === '合计' || name === '汇总'
    },
    canSeeRowDetail (item) {
      if (!item || this.isTotalRow(item) || !item.adviserId) {
        return false
      }
      return !!item.canSeeDetail
    },
    goToPerformanceDetail (item) {
      if (!this.canSeeRowDetail(item)) {
        return
      }
      const month = this.$moment(this.queryParam.month).format('YYYY-MM')
      this.$router.push({
        path: '/order/studyAdviserPerformanceDetail',
        query: {
          month: month,
          adviserId: item.adviserId,
          tchChannel: this.queryParam.tchChannel || 1
        }
      })
    },
    exportToImage () {
      if (this.rankingData.length === 0) {
        this.$Message.warning('暂无数据，无法导出')
        return
      }
      this.exportLoading = true
      const el = this.$refs.exportArea
      html2canvas(el, {
        scale: 2,
        backgroundColor: '#ffffff',
        useCORS: true,
        onclone: function (clonedDoc) {
          const badges = clonedDoc.querySelectorAll('.medal-gold, .medal-silver, .medal-bronze')
          badges.forEach(badge => {
            const isGold = badge.classList.contains('medal-gold')
            const isSilver = badge.classList.contains('medal-silver')
            const number = isGold ? '1' : (isSilver ? '2' : '3')
            const bgColor = isGold
              ? 'linear-gradient(135deg, #ffd700 0%, #ffed4e 100%)'
              : (isSilver
                ? 'linear-gradient(135deg, #c0c0c0 0%, #e8e8e8 100%)'
                : 'linear-gradient(135deg, #cd7f32 0%, #e8a87c 100%)')
            const textColor = isGold ? '#8b6914' : (isSilver ? '#5a5a5a' : '#8b5a2b')
            badge.innerHTML = number
            Object.assign(badge.style, {
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '32px',
              height: '32px',
              borderRadius: '50%',
              fontWeight: '700',
              fontSize: '16px',
              background: bgColor,
              color: textColor
            })
          })
        }
      }).then(canvas => {
        const link = document.createElement('a')
        link.download = '班主任龙虎榜_' + this.$moment(this.queryParam.month).format('YYYY-MM') + '.png'
        link.href = canvas.toDataURL('image/png')
        link.click()
        this.exportLoading = false
        this.$Message.success('导出成功')
      }).catch(() => {
        this.exportLoading = false
        this.$Message.error('导出失败')
      })
    },
    getNewOrders () {
      const self = this
      self.$http.get('/fundPackage/studyAdviserNewOrders').then(function (res) {
        if (res && res.data) {
          self.newOrderList = res.data
        } else {
          self.newOrderList = []
        }
      }).catch(() => {
        self.newOrderList = []
      })
    }
  }
}
</script>

<style lang="less" scoped>
.dragon-tiger-rank-v2 {
  min-height: 100%;
  background: #f0f2f5;
  padding: 0;
}

// 页面头部
.page-header {
  background: linear-gradient(135deg, #ff9900 0%, #ffb347 100%);
  border-radius: 8px;
  padding: 8px 12px;
  margin-bottom: 5px;
  box-shadow: 0 2px 8px rgba(255, 153, 0, 0.2);

  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    width: 100%;
  }

  .title-wrapper {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;

    h1 {
      margin: 0;
      font-size: 22px;
      font-weight: 700;
      color: #fff;
      letter-spacing: 0.5px;
    }

    .subtitle {
      font-size: 12px;
      color: rgba(255, 255, 255, 0.85);
      margin-left: 6px;
    }
  }

  // 业绩播报跑马灯
  .news-marquee {
    flex: 1;
    overflow: hidden;
    position: relative;
    height: 24px;
    display: flex;
    align-items: center;
    background: linear-gradient(135deg, #ff9900 0%, #ffb347 100%);
    border-radius: 6px;
    padding: 0 12px;

    .marquee-content {
      position: absolute;
      white-space: nowrap;
      animation: marqueeScroll 30s linear infinite;
      display: flex;
      align-items: center;
      gap: 20px;
      left: 100%;

      &:hover {
        animation-play-state: paused;
      }
    }

    .marquee-item {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      font-size: 13px;
      color: #fff;
      white-space: nowrap;
    }
  }

  @keyframes marqueeScroll {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-100%);
    }
  }
}

// 主内容区
.main-content {
  // 统计卡片
  .stat-cards {
    margin-bottom: 20px;

    .stat-card {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 16px;
      padding: 16px;
      border-radius: 10px;
      transition: all 0.3s ease;
      cursor: pointer;
      height: 90px;

      &:hover {
        transform: translateY(-3px);
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
      }

      .stat-icon {
        width: 52px;
        height: 52px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
      }

      .stat-info {
        text-align: left;

        .stat-label {
          font-size: 13px;
          color: rgba(0, 0, 0, 0.65);
          white-space: nowrap;
        }
      }

      .stat-value {
        font-size: 24px;
        font-weight: 700;
        line-height: 1;
        white-space: nowrap;
      }

      &.quantity {
        background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);

        .stat-icon {
          background: rgba(255, 255, 255, 0.2);
        }

        .stat-value {
          color: #fff;
        }

        .stat-label {
          color: rgba(255, 255, 255, 0.9);
        }
      }

      &.amount {
        background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);

        .stat-icon {
          background: rgba(255, 255, 255, 0.2);
        }

        .stat-value {
          color: #fff;
        }

        .stat-label {
          color: rgba(255, 255, 255, 0.9);
        }
      }
    }
  }

  // 搜索卡片
  .search-card {
    margin-bottom: 16px;
    border-radius: 8px;
    padding: 4px 16px;

    /deep/ .ivu-form-item {
      margin-bottom: 8px;
    }
  }

  // 排行榜卡片
  .rank-card {
    border-radius: 8px;
    overflow: hidden;
    max-width: 50%;
    margin: 0 auto;

    .rank-card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 8px 16px;
      border-bottom: 1px solid #e8e8e8;

      .rank-title {
        font-size: 14px;
        font-weight: 600;
        color: #333;
      }
    }

    .table-wrapper {
      overflow-x: auto;
      padding: 8px;
    }

    .rank-table {
      width: 100%;
      border-collapse: collapse;
      font-size: 12px;

      thead {
        tr {
          background: linear-gradient(135deg, #ff9900 0%, #ffb347 100%);
          color: #fff;

          th {
            padding: 6px 8px;
            text-align: center;
            font-weight: 600;
            font-size: 12px;
            border: none;

            &:first-child {
              border-radius: 8px 0 0 8px;
            }

            &:last-child {
              border-radius: 0 8px 8px 0;
            }
          }
        }
      }

      tbody {
        .rank-row {
          transition: all 0.3s ease;

          &:hover {
            background: #f6f8fa;
            transform: scale(1.01);
          }

          td {
            padding: 6px 8px;
            text-align: center;
            border-bottom: 1px solid #e8e8e8;
          }

          &.rank-1 {
            background: linear-gradient(135deg, #fff9e6 0%, #fff3cd 100%);

            td {
              border-bottom-color: #ffe69c;
            }
          }

          &.rank-2 {
            background: linear-gradient(135deg, #f0f5ff 0%, #e6f0ff 100%);

            td {
              border-bottom-color: #b3d1ff;
            }
          }

          &.rank-3 {
            background: linear-gradient(135deg, #fff0f0 0%, #ffe6e6 100%);

            td {
              border-bottom-color: #ffb3b3;
            }
          }
        }

        .rank-col {
          .rank-badge {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 32px;
            height: 32px;
            border-radius: 50%;
            font-weight: 700;
            font-size: 14px;
            transition: all 0.3s ease;

            &.medal-gold {
              background: linear-gradient(135deg, #ffd700 0%, #ffed4e 100%);
              color: #8b6914;
              box-shadow: 0 4px 12px rgba(255, 215, 0, 0.4);
              font-size: 20px;
            }

            &.medal-silver {
              background: linear-gradient(135deg, #c0c0c0 0%, #e8e8e8 100%);
              color: #5a5a5a;
              box-shadow: 0 4px 12px rgba(192, 192, 192, 0.4);
              font-size: 20px;
            }

            &.medal-bronze {
              background: linear-gradient(135deg, #cd7f32 0%, #e8a87c 100%);
              color: #8b5a2b;
              box-shadow: 0 4px 12px rgba(205, 127, 50, 0.4);
              font-size: 20px;
            }
          }
        }

        .dept-col {
          font-weight: 500;
          color: #333;
        }

        .name-col {
          font-weight: 600;
          color: #333;

          a {
            color: #2d8cf0;
            cursor: pointer;
            text-decoration: none;

            &:hover {
              text-decoration: underline;
            }
          }
        }

        .quantity-col {
          font-weight: 600;
          color: #f5576c;
          font-size: 13px;
        }

        .amount-col {
          font-weight: 700;
          color: #4facfe;
          font-size: 13px;
        }

        .ranking-col {
          .ranking-badge {
            display: inline-block;
            width: 32px;
            height: 32px;
            line-height: 32px;
            background: #f0f0f0;
            border-radius: 50%;
            font-weight: 600;
            color: #666;
          }
        }

        .total-row {
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);

          td {
            padding: 10px;
            font-size: 13px;
            border-bottom: none;
          }

          .total-col {
            color: #333;
            text-align: center;

            strong {
              color: #2d8cf0;
              font-size: 13px;
            }
          }
        }
      }
    }

    .empty-data {
      text-align: center;
      padding: 60px 20px;
      color: #999;

      p {
        margin-top: 16px;
        font-size: 16px;
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .page-header {
    padding: 16px 20px;

    .title-wrapper {
      h1 {
        font-size: 22px;
      }
    }
  }

  .stat-cards {
    .stat-card {
      .stat-icon {
        width: 48px;
        height: 48px;

        i {
          font-size: 24px;
        }
      }

      .stat-info {
        .stat-label {
          font-size: 12px;
        }

        .stat-value {
          font-size: 22px;
        }
      }
    }
  }

  .rank-table {
    font-size: 13px;

    th, td {
      padding: 10px 8px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// StudyAdviserDragonTigerList.vue?ca5c31f8